import React, { useState } from "react";
import HelpCenterQuickActions from "../../components-v2/profile-menu/helpcenter/HelpCenterQuickActions";
import HelpCenterFAQ from "../../components-v2/profile-menu/helpcenter/HelpCenterFAQ";
import HelpCenterGettingStarted from "../../components-v2/profile-menu/helpcenter/HelpCenterGettingStarted";
import HelpCenterResources from "../../components-v2/profile-menu/helpcenter/HelpCenterResources";
import HelpCenterContactForm from "../../components-v2/profile-menu/helpcenter/HelpCenterContactForm";
import HelpCenterContactInfo from "../../components-v2/profile-menu/helpcenter/HelpCenterContactInfo";
import { SearchIcon } from "../../components-v2/profile-menu/helpcenter/HelpCenterIcons";
import "../../styles-v2/profile-menu/v2-help-center-page.css";

const HelpCenterPage = () => {
  const [search, setSearch] = useState("");

  return (
    <div className="v2-help-pg">
      {/* Header */}
      <div className="v2-help-pg__header">
        <h1 className="v2-help-pg__title">Help Center</h1>
        <p className="v2-help-pg__subtitle">
          Find answers, watch tutorials, and get support for all your questions
        </p>
      </div>

      {/* Search */}
      <div className="v2-help-pg__search-wrap">
        <SearchIcon size={20} color="#9ca3af" />
        <input
          type="text"
          className="v2-help-pg__search-input"
          placeholder="Search for help..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* Quick Actions */}
      <HelpCenterQuickActions />

      {/* Main Content Grid */}
      <div className="v2-help-pg__grid">
        {/* Left Column */}
        <div className="v2-help-pg__grid-left">
          <HelpCenterFAQ />
          <HelpCenterContactForm />
        </div>

        {/* Right Column */}
        <div className="v2-help-pg__grid-right">
          <HelpCenterGettingStarted />
          <HelpCenterResources />
          <HelpCenterContactInfo />
        </div>
      </div>
    </div>
  );
};

export default HelpCenterPage;
